import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dashboard-leagues',
  templateUrl: './dashboard-leagues.component.html',
  styleUrls: ['./dashboard-leagues.component.css']
})
export class DashboardLeaguesComponent implements OnInit {

  leagueForm: FormGroup;
  id: number;
  countryData: any = {};
  searchText: any;
  currentUser: any;
  isLoaderVisible = false;
  submitted = false;
  isSubmitted = true;
  countryId: number;
  countryName: string;
  errorMessage: string = '';


  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService,

  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.countryDetails();
    this.leagueForm = this.formBuilder.group({
      countryId: [this.id],
      leagueName: ['', Validators.required],
      leagueClass: [''],
      leagueDescription: ['', Validators.required],
      leagueLogo: ['', Validators.required],
      createdBy: [this.currentUser.success.user.id],
    });
  }
  countryDetails() {
    this.isLoaderVisible = true;
    const data = {
      countryId: this.id,
    };
    this.iffhsService.getCountryDetails(data).pipe(first<any>())
      .subscribe(countryData => this.countryData = countryData[0]);
    this.countryId = this.countryData.id;
    this.countryName = this.countryData.name;
    this.isLoaderVisible = false;
  }
  onFileSelect(event) {
    const leagueLogo = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only images are supported', 'Message!');
      return;
    }
    this.leagueForm.get('leagueLogo').setValue(leagueLogo);

  }
  get f() { return this.leagueForm.controls; }
  addLeague() {
    this.submitted = true;
    if (this.leagueForm.invalid) {
      return;
    }
    this.isLoaderVisible = true;
    const fd = new FormData();
    fd.append('countryId', this.leagueForm.get('countryId').value);
    fd.append('leagueName', this.leagueForm.get('leagueName').value);
    fd.append('leagueClass', this.leagueForm.get('leagueClass').value);
    fd.append('leagueDescription', this.leagueForm.get('leagueDescription').value);
    fd.append('createdBy', this.leagueForm.get('createdBy').value);
    fd.append('leagueLogo', this.leagueForm.get('leagueLogo').value);


    this.iffhsService.addLeague(fd).pipe(first()).subscribe(
      data => {
        this.toastrService.success('Football League Added!', 'Message!');
        this.isLoaderVisible = false;
        this.submitted = true;
      },
      error => {
        console.log(error);
        this.isLoaderVisible = false;
        this.toastrService.error('Something went wrong please Try Later!', 'Message!');

      }
    );
    this.resetForm();
  }
  resetForm() {
    this.leagueForm = this.formBuilder.group({
      countryId: [this.id],
      leagueName: [''],
      leagueClass: [''],
      leagueDescription: [''],
      leagueLogo: [''],
      createdBy: [this.currentUser.success.user.id],
    });
  }

}
